// ============================================================================
// Table Columns: UserGroups
// Key: userGroups
// Generated file. Do not edit manually.
// ============================================================================

// #region Imports
import {
	cellRenderer,
	type EntityTableConfig,
} from '../../entity-config-runtime/entity-table-config'
import type { UserGroupSummary } from '../api/backstage.schemas'
// #endregion

// #region Client List Columns
export const userGroupsClientGetColumnsConfig = {
	columns: ['name', cellRenderer('membersCount', 'number')],
} as const satisfies EntityTableConfig<UserGroupSummary>
// #endregion

// #region Columns Config Export
export const userGroupsColumnsConfig = {
	client: {
		get: userGroupsClientGetColumnsConfig,
	},
} as const
// #endregion
